import PropTypes from 'prop-types';
import { noop } from 'node-noop';

import displayModes from '../constants/display-mode';
import dataChangedDefaultTimeout from '../constants/data-changed-default-timeout';

export const defaultProps = {
  targetWidth: '',
  style: {},
  content: '',
  hideLinkStyleOption: false,
  callback: noop,
  onDataChanged: noop,
  dataChangedTimeout: dataChangedDefaultTimeout
};

export const fakeProps = {
  editorConfig: {
    editorId: 'test-editor-id',
    blankPageURL: '/test/editor/blank/page',
    toolbarConfigKey: 'test-editor-toolbar-config-key',
    minEditorHeight: 100
  },
  toolbarConfig: {
    toolbarContainerId: 'test-editor-toolbar-container-id',
    pToolbarStruct: 'test-editor-pToolbarStruct'
  },
  className: 'test-class',
  targetWidth: '100px',
  style: { float: 'left' },
  content: 'content-to-check',
  onDataChanged: noop
};

export default {
  editorConfig: PropTypes.shape({
    editorId: PropTypes.string.isRequired,
    blankPageURL: PropTypes.string.isRequired,
    displayMode: PropTypes.oneOf(
      Object.values(displayModes)
    ),
    toolbarConfigKey: PropTypes.string.isRequired,
    autoStart: PropTypes.bool,
    autoFocus: PropTypes.string,
    minEditorHeight: PropTypes.number,
    mainIdForBodyStyles: PropTypes.string,
    mainClassForBodyStyles: PropTypes.string,
    extParameters: PropTypes.object
  }).isRequired,
  toolbarConfig: PropTypes.shape({
    toolbarContainerId: PropTypes.string.isRequired,
    pToolbarStruct: PropTypes.string.isRequired,
    args: PropTypes.object
  }).isRequired,
  targetWidth: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.string),
  content: PropTypes.string,
  hideLinkStyleOption: PropTypes.bool,
  callback: PropTypes.func,
  onDataChanged: PropTypes.func,
  dataChangedTimeout: PropTypes.number
};